module.exports = __webpack_public_path__ + "img/illustrations/contact-csv-upload-bf6ec5b1a7b38de750be52c28a6b2a70.svg";